export const CRAZY_EGG_CONVERSION_EVENTS = {
  PRO_TRIAL: '3088fe1b-e516-4f1e-9066-ab8295f9c57a',
  PURCHASED_VGB: '894f03c0-90f5-4e46-9353-97eba89dd3f9',
  PURCHASED_MSS: '745aa55a-18ad-44c4-95eb-f6fe81dd08b5',
  PURCHASED_GOLD: 'df8fbdf6-6aa4-40c2-a3df-a64c0c2a85a3',
  PAID_EVENT_CREATED: '0888490f-769e-4dbb-ac1a-3ae1ca4aec39',
  FREE_EVENT_CREATED: 'e8ef7622-e011-4fd2-9d12-35276290920d',
  GOLD_PROMPT_SEEN: '6db69b9a-539f-4658-aed5-90f44ab396ab',
  BUNDLE_PROMPT_SEEN: '46b7919e-fc48-455a-92d5-2b6ef4921b64',
  GOLD25_USED: '4b0ee7f2-833e-41bb-b070-3fe7344874a6',
  GOLD2FOR1_USED: '209257bf-ae75-4403-bb98-9f8393f09913',
  GOLD_VARIANT_A_SEEN: '430c4fda-47ed-4fd2-b8d0-190eabce4586',
  GOLD_VARIANT_B_SEEN: '595387a3-3a07-42f2-870e-dfa50acbb5fe',
  GOLD_VARIANT_A_PURCHASE: '24155015-b232-426b-855b-5d41c5eef990',
  GOLD_VARIANT_B_PURCHASE: '600e9207-f572-4089-99cb-c4fb82a56bc3',
};
